import { Box, IconButton, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import TextField from "../../../components/form/TextField";
import React, { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
    data: any;
    close: () => void
}

interface FormValues {
    firstName: string;
    lastName: string;
    institution: string;
    email: string;
}

const PendingUser = (props: Props) => {
    const { data } = props;
    const { control, formState: { errors }, setValue } = useForm<FormValues>({
        defaultValues: {
            firstName: "",
            lastName: "",
            institution: "",
            email: ""
        }
    });
    useEffect(() => {
        setValue("firstName", data.firstName);
        setValue("lastName", data.lastName);
        setValue("institution", data.institution);
        setValue("email", data.email);
    }, [data])

    return (
        <Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between'
                }}
            >
                <Typography variant="h6" gutterBottom>
                    User Info
                </Typography>
                <IconButton size="small" onClick={props.close}>
                    <CloseIcon fontSize="inherit"/>
                </IconButton>
            </Box>
            <form
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    minWidth: 356,
                }}
            >
                <Controller
                    name={"firstName"}
                    control={ control }
                    render={({ field }) => (
                        <TextField
                            label={"First Name"}
                            error={errors.firstName ? true : false }
                            // errorMessage={errors.firstName ? "First name is required" : undefined}
                            disabled={true}
                            { ...field }
                        />
                    )}
                />
                <Controller
                    name={"lastName"}
                    control={ control }
                    render={({ field }) => {
                        return (
                            <TextField
                                label={"Last Name"}
                                error={errors.lastName ? true : false }
                                // errorMessage={errors.lastName ? "Last name is required" : undefined}
                                disabled={true}
                                { ...field }
                            />
                        )}}
                />
                <Controller
                    name={"institution"}
                    control={ control }
                    render={({ field }) => (
                        <TextField
                            label={"Institution"}
                            error={errors.institution ? true : false }
                            // errorMessage={errors.institution ? "Institution is required" : undefined}
                            disabled={true}
                            { ...field }
                        />
                    )}
                />
                <Controller
                    name={"email"}
                    control={ control }
                    render={({ field }) => (
                        <TextField
                            label={"Institutional Email Address"}
                            error={errors.email ? true : false }
                            // errorMessage={errors.email ? "Email is required" : undefined}
                            disabled={true}
                            { ...field }
                        />
                    )}
                />
            </form>
        </Box>
    )
}

export default PendingUser